/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { FC, ReactNode, SyntheticEvent } from "react";
import { DialogButton } from "./DialogButton";

export interface ErrorDialogProps {
  open: boolean;
  message: string | ReactNode;
  positiveButtonText: string;
  onPositiveButtonClick: (
    event: SyntheticEvent<unknown>,
    reason?: string
  ) => void;
}

export const ErrorDialog: FC<ErrorDialogProps> = ({
  open,
  message,
  positiveButtonText,
  onPositiveButtonClick,
}) => {
  return (
    <Dialog
      disableEscapeKeyDown
      open={open}
      className="alert"
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "20vw",
          bgcolor: "error.light",
        },
      }}
    >
      <DialogContent
        sx={{
          "&.MuiDialogContent-root": {
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            padding: "40px 24px 8px",
          },
        }}
      >
        <DialogContentText
          sx={{
            "&.MuiDialogContentText-root": {
              fontWeight: "bold",
              color: "text.primary",
            },
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ bgcolor: "error.light" }}>
        <DialogButton onClick={onPositiveButtonClick}>
          {positiveButtonText}
        </DialogButton>
      </DialogActions>
    </Dialog>
  );
};
